<div class="registration-toolbar">
    <icon id="alignLogo" iconName="invisalign_itero_exocad_logo" (dblclick)="showVersion()"></icon>
    <mat-select id="languages" class="languages" [(value)]="selectedLanguage" (selectionChange)="languageChanged($event.value)">
        <mat-option *ngFor="let language of languages" [value]="language.code">
            {{language.localizedName}}
        </mat-option>
    </mat-select>
</div>